import * as React from "react";

interface OverviewSectionProps {}

const goToChatSubdomain = () => {
  const { hostname, protocol, port } = window.location;

  const baseHost = hostname.replace(/^chat\./, '');

  const chatHost = `chat.${baseHost}`;

  const fullURL = `${protocol}//${chatHost}${port ? `:${port}` : ''}`;
  window.location.href = fullURL;
};

const OverviewSection: React.FC<OverviewSectionProps> = ({}) => {
  const handleKeyPress = (event: React.KeyboardEvent, action: () => void) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      action();
    }
  };

  return (
    <section
      role="tabpanel"
      id="overview-panel"
      aria-labelledby="overview-tab"
      tabIndex={0}
      className="flex justify-center items-center px-6 py-0 h-screen text-center"
    >
      <div className="max-w-[800px]">
        <h1 className="mb-6 text-6xl font-bold">نسل جدید پلتفرم هوش مصنوعی</h1>
        <p className="mb-10 text-xl leading-relaxed text-neutral-400">
          بساز و منتشر کن دستیارهای هوش مصنوعی مجهز به جدیدترین مدل‌ها.
          بهره‌وری و خلاقیت را با مجموعه‌ای کامل از ابزارهای هوش مصنوعی ما افزایش بده.
        </p>
        <button
          className="px-6 py-3 text-lg font-medium text-black bg-white rounded-xl transition-all cursor-pointer border-[none] duration-[0.2s] min-w-[280px]"
          aria-label="Start Building"
          onKeyDown={(event) =>
            handleKeyPress(event, goToChatSubdomain)
          }
          onClick={goToChatSubdomain}
        >
          شروع کنید
        </button>
      </div>
    </section>
  );
};

export default OverviewSection;
